import React, {useContext, useEffect, useState} from 'react';
import {MobileMenuContext} from "../../common/context/mobile-menu-context";
import Testimonials from "./testimonials/testimonials";
import Galerie from "../inside-look/inside-look";
import WhyChooseUs from "./why-choose-us/why-choose-us";
import ParallaxSection from "./parallax/parallax-section";
import ProgramOverview from "./program-overview/program-overrview";
import AvailableSpots from "./available-spots/available-spots";
import FAQ from "./faq/faq";
import CenteredPageContainer from "../../common/centeredcontainer/centered-page-container";
import FooterXsci from "../../common/footer/footer-xsci";
import NavBar from "../../v2/layout/navigation/navBar";
import HeroBanner from "../../v2/layout/banner/HeroBanner";


const useWindowWidth = () => {
    const [width, setWidth] = useState(window.innerWidth);
    const {isMobileMenuOpen, setIsMobileMenuOpen} = useContext(MobileMenuContext);
    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        console.log("isMobileMenuOpen <<HOME>>", isMobileMenuOpen)
       // setIsMobileMenuOpen(true);
    }, []);

    return width;
};

const HomePage: React.FC = () => {
    const width = useWindowWidth();
    const isMobile = width <= 768;
    const isMobileOrRegularIpad = width < 1024;
    const {isMobileMenuOpen, setIsMobileMenuOpen} = useContext(MobileMenuContext);
    const [transition, setTransition] = useState("fade");
    function changeTransition(transition: string) {
        setTransition(transition);
    }

    // const title = "Garderie familiale à La Prairie.";
    const title = "Bienvenue à la Garderie La Belle Étoile"
    const subTitle = "Service de garde de confiance depuis plus de 12 ans.";
    const subtitle2 = "Un accueil personnalisé pour chaque enfant avec amour, amitié et pédagogie.";

    return (
        <>
            {/*<NavbarTest />*/}
            <NavBar/>

            {/*<HeroBanner*/}
            {/*    backgroundImageUrl={"/images/banner/new.jpg"}*/}
            {/*    title= {title}*/}
            {/*    subtitle1={subtitle1}*/}
            {/*    subtitle2={subtitle2}*/}
            {/*    subtitle3={subtitle3}*/}
            {/*    showButton={true}*/}
            {/*/>*/}
            {/*<HeroBannerV2*/}
            {/*    title={title}*/}
            {/*    subtitle3={subtitle3}*/}
            {/*    backgroundImageUrl={"/images/banner/new.jpg"}*/}
            {/*    showButton={true}*/}
            {/*/>*/}
            <HeroBanner
                title={title}
                subTitle={subTitle}
                subTitle2={subtitle2}
                imageUrl={"/images/home/img.png"}
                hideCta={false}
            />
            {/*<HeroSection*/}
            {/*    title="Hello World!"*/}
            {/*    description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam tincidunt enim ac augue suscipit rhoncus. Donec ante erat, hendrerit sed eleifend et, dapibus at leo. Mauris bibendum mi ut dui sagittis volutpat."*/}
            {/*    buttonText="Click me, I'm a button"*/}
            {/*    imageUrl="/images/banner/new.jpg"*/}
            {/*/>*/}
            <CenteredPageContainer component={() => (
                <>
                    <WhyChooseUs/>
                    <ProgramOverview/>
                    <AvailableSpots/>
                    <ParallaxSection/>
                    {/*<Testimonials/>*/}
                    <FAQ/>
                    <Galerie/>
                    <FooterXsci/>
                </>
            )} />

        </>
    );
};

export default HomePage;